import { PROFILE_SELECTED } from '../constants/userProfileConstants';

export default function selectProfile(id) {
  return { type: PROFILE_SELECTED, payload: id };
}
